<template>
    <div class="card">
        <h4>Debugger</h4>
        <pre>{{data}}</pre>
    </div>
</template>

<script>

    export default {
        props: ['data'],
        mounted() {
            console.log('DEBUG Screen Active')
        }
    }
</script>

<style scoped>
    .card {
        padding: 1em;
    }
    .card pre {
        overflow-y: scroll;
        height: 63vh;
    }
</style>
